<template>
  <div class="content-container">
    <div class="spinner-container">
      <span
        v-if="saving"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </div>
    <span :class="{ 'opacity-none': saving }">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: "z-saving-spinner",
  props: ["saving"],
};
</script>

<style scoped>
.content-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-border {
}

.opacity-none {
  opacity: 0;
}
</style>
